import { Link } from "react-router-dom";
import type { Work } from "@/types/content";

export default function WorkCard({ work }: { work: Work }) {
  return (
    <Link
      to={`/works/${work.id}`}
      className="group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={work.cover}
          alt={`《${work.title}》海报`}
          title={`${work.title} - 筱田优影视作品`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent" />
        <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-background-50/90 text-foreground-900 text-xs font-medium">
          {work.type}
        </span>
        <span className="absolute top-3 right-3 px-2.5 py-1 rounded-md bg-accent-500 text-background-50 text-xs font-bold">
          {work.rating.toFixed(1)}
        </span>
        <div className="absolute bottom-0 left-0 right-0 p-3">
          <h3 className="font-heading text-base font-bold text-background-50 line-clamp-1">{work.title}</h3>
          <p className="text-xs text-background-50/80 mt-1">
            {work.year} · {work.director} 执导
          </p>
        </div>
      </div>
      <div className="p-3.5">
        <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">{work.synopsis}</p>
        <div className="flex items-center gap-2 mt-3 flex-wrap">
          {work.tags.slice(0, 2).map((tag) => (
            <span key={tag} className="text-xs text-secondary-700 bg-secondary-100 px-2 py-0.5 rounded-md">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}